import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { WorkflowStep } from '@app/models/workflow-step';
// import { Router } from '@angular/router'
import { OrchestratorService } from '@app/services/orchestrator.service';
import { StepperService } from '@app/services/stepper.service';
import { StoreService } from '@app/services/store.service';
// import { PreviousRouteService } from '@app/services/previous-route.service'
import { Observable, Subject, takeUntil } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
	selector: 'mv-other-owners',
	templateUrl: './other-owners.component.html',
	styleUrls: ['./other-owners.component.scss'],
})
export class OtherOwnersComponent implements OnInit, OnDestroy {
	@Output() _emb_close: EventEmitter<boolean> = new EventEmitter<boolean>();
	public ownersForm: FormGroup;
	public hideOwnersInput: boolean = true;
	public petName$: Observable<string> = this.storeService.appState$.pipe(map(s => s.petName ?? ''));
	public clinicName$: Observable<string> = this.storeService.formState$.pipe(
		map(s => {
			if (s.vetClinic?.accountName) return s.vetClinic?.accountName;
			else if (s.newVetClinic?.name) return s.newVetClinic?.name;
			else return '';
		})
	);
	// private readonly previousRouteSegments: string[] | null
	private readonly workflowStep: number = 2;
	private readonly snackBarRef?: MatSnackBarRef<TextOnlySnackBar>;
	private readonly ngUnsubscribe$: Subject<boolean> = new Subject();
	private readonly maxInputLength: number = 100;

	constructor(
		public readonly el: ElementRef<HTMLElement>,
		// private readonly previousRouteService: PreviousRouteService,
		private readonly fb: FormBuilder,
		private readonly orchestratorService: OrchestratorService,
		private readonly snackbar: MatSnackBar,
		private readonly stepperService: StepperService,
		private readonly storeService: StoreService
	) {
		// this.previousRouteSegments = this.previousRouteService.getPreviousRouteSegments()

		this.ownersForm = this.fb.group({
			hasOtherOwners: [null, Validators.required],
			otherOwners: [null, Validators.maxLength(this.maxInputLength)],
		});

		// FIXME: Update to use new pattern
		this.storeService.formState$.pipe(first()).subscribe(({ hasOtherOwners, otherOwnersValue: otherOwners }) => {
			this.hideOwnersInput = !hasOtherOwners;
			this.ownersForm.patchValue({
				hasOtherOwners,
				otherOwners,
			});
		});
	}

	private get hasOtherOwnersControl(): AbstractControl | null {
		return this.ownersForm.get('hasOtherOwners');
	}

	private get otherOwnersControl(): AbstractControl | null {
		return this.ownersForm.get('otherOwners');
	}

	ngOnInit(): void {
		this.stepperService.updateStep(this.workflowStep);

		this.hasOtherOwnersControl?.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value => {
			console.log(`hasOtherOwners: ${value}`);
			if (!value) {
				this.hideOwnersInput = true;
				this.otherOwnersControl?.reset();
				this.otherOwnersControl?.clearValidators();
			}

			if (value) {
				this.hideOwnersInput = false;
				this.otherOwnersControl?.setValidators(Validators.required);
			}

			this.otherOwnersControl?.updateValueAndValidity();
		});
	}

	public nextStep(): void {
		if (this.ownersForm.invalid) return;

		// FIXME: Update to use new patterns
		const { hasOtherOwners, otherOwners: otherOwnersValue } = this.ownersForm.getRawValue();
		this.storeService.updateFormState({
			hasOtherOwners,
			otherOwnersValue,
		});
		this.storeService.updateWorkflowStep(WorkflowStep.OtherNames);
	}

	public stepBack(): void {
		if (this.storeService.previousWorkflowStep === WorkflowStep.AddNewVet) {
			this.storeService.navigateToPreviousStep();

			return;
		}

		this.storeService.updateWorkflowStep(WorkflowStep.VetClinic);
	}

	public cancel(): void {
		this._emb_close.emit(false);
		this.storeService.cleanupFormState();
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe$.next(true);
		this.ngUnsubscribe$.unsubscribe();
	}
}
